import React from "react";
import GameModuleFrame from "../../game-platform/GameModuleFrame";

export const outdoorCapabilities = Object.freeze({
  map: true,
  location: true,
  timedQuestions: true,
  physicalItems: false,
});

const outdoorDefaults = Object.freeze({
  backgroundColor: "#0F1114",
  surfaceColor: "#111111",
  textColor: "#F2EDE4",
  accentColor: "#D8D3C8",
  textureOpacity: 0.3,
});

export default function OutdoorGameApp(props) {
  return (
    <GameModuleFrame
      {...props}
      moduleId="outdoor"
      defaults={outdoorDefaults}
      capabilities={outdoorCapabilities}
    />
  );
}
